import { z } from 'zod'

const measureUnitSchema = z.object({
  id: z.number().optional(),
  measureTypeId: z.number().optional(),
  name: z.string().optional(),
  units: z.string().optional(),
  siConversionFactor: z.number().optional(),
  isSiUnit: z.boolean().optional(),
})

const physicalPropertiesSchema = z
  .object({
    id: z.number().optional(),
    weightMeasureUnitId: z.number().optional(),
    weightMeasureUnit: measureUnitSchema.optional(),
    volumeMeasureUnitId: z.number().optional(),
    volumeMeasureUnit: measureUnitSchema.optional(),
    densityMeasureUnitId: z.number().optional(),
    densityMeasureUnit: measureUnitSchema.optional(),
    lengthMeasureUnitId: z.number().optional(),
    lengthMeasureUnit: measureUnitSchema.optional(),
    netWeight: z.number().optional(),
    grossWeight: z.number().optional(),
    chargeableWeight: z.number().optional(),
    volume: z.number().optional(),
    density: z.number().optional(),
    height: z.number().optional(),
    length: z.number().optional(),
    width: z.number().optional(),
    maxLoadingHeight: z.number().optional(),
    updatedByUserId: z.number().optional(),
    useDimensions: z.boolean().optional(),
    isRectangular: z.boolean().optional(),
    tareWeight: z.number().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.useDimensions) {
      if (!data.length) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Length is required',
          path: ['length'],
        })
      }
      if (data.isRectangular) {
        if (!data.width) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Width is required',
            path: ['width'],
          })
        }
        if (!data.height) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Height is required',
            path: ['height'],
          })
        }
        }
    } else {
      if (!data.volume) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Volume is required',
          path: ['volume'],
        })
      }
    }
  })

export const loadTemplateSchema = z.object({
  id: z.number().optional(),
  customerId: z.number().optional(),
  tenantId: z.number().optional(),
  loadTypeId: z.number({ required_error: 'Load Type is required' }),
  loadType: z.object({ id: z.number(), name: z.string() }).optional(),
  physicalPropertiesId: z.number().optional(),
  physicalProperties: physicalPropertiesSchema,
  name: z.string(),
  isoCode: z.string().optional(),
  systemDefined: z.boolean().optional(),
  isCustomerSelectable: z.boolean().optional(),
  inUse: z.boolean().nullable().optional(),
})

export type LoadTemplateFormData = z.infer<typeof loadTemplateSchema>
